import {
  applyThemeVariables,
  useColorScheme,
  usePortalThemeBase,
} from '@asset-metrix/portal-ui';

import { useLoginInfoQuery } from '../api/portalGateway/loginInfo';

export { applyThemeVariables, useColorScheme };

export function usePortalTheme() {
  const loginInfoQuery = useLoginInfoQuery();

  return usePortalThemeBase(loginInfoQuery.data?.theme);
}
